<template>
    <node-view-wrapper>
        <div class="custom-signature" v-html="signature" />
    </node-view-wrapper>
</template>

<script>
import { NodeViewWrapper, nodeViewProps } from '@tiptap/vue-3';
export default {
    components: {
        NodeViewWrapper,
    },
    props: nodeViewProps,
    computed: {
        signature() {
            return this.node.attrs.signature;
        },
    },
};
</script>

<style lang="scss">
.ProseMirror .custom-signature {
    table,
    td,
    th {
        border: inherit;
    }
}
</style>
